// Mirrored in applications/platform-app/components/web-analytics — change both.
import React, { useState } from 'react';
import { useDash } from '../context';
import { useBreakdown, useRows } from '../tabs/shared';
import { BarList } from '../charts/BarList';
import { ErrorLine, Modal, TextInput } from '../ui';
import { RubyLoader } from '../../RubyLoader';
import type { WebDim } from '../types';

/** Every row of one breakdown (limit 100). A row click filters the dashboard and closes. */
export const ViewAllModal: React.FC<{ dim: WebDim; title: string; onClose: () => void }> = ({ dim, title, onClose }) => {
  const d = useDash();
  const q = useBreakdown(dim, 100);
  const toRows = useRows();
  const [needle, setNeedle] = useState('');
  const rows = toRows(dim, q.data?.rows, dim === 'page' ? (r) => r.pv : undefined)
    .map((r) => ({ ...r, onClick: r.onClick ? () => { r.onClick!(); onClose(); } : undefined }))
    .filter((r) => !needle || String(r.title || '').toLowerCase().includes(needle.toLowerCase()));
  return (
    <Modal title={`All ${title.toLowerCase()}`} onClose={onClose} testId="wa-viewall-modal" width={620}>
      <div className="mb-2"><TextInput value={needle} onChange={(e) => setNeedle(e.target.value)} placeholder="Search…" /></div>
      {q.error ? <ErrorLine message={q.error} /> : q.loading && !q.data ? <RubyLoader variant="section" label="Loading" /> : (
        <BarList rows={rows} limit={100} />
      )}
      {d.filtered && <div className="text-[11px] text-stone-500 mt-2">Showing the filtered segment only.</div>}
    </Modal>
  );
};

export default ViewAllModal;
